// Filename - pages/ContactUs.js

import React, { useEffect, useState } from "react";
import { Card, Nav, Button, Row, Col, } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import UtilityCharges from "./UtilityCharges";
import MasterValue from "./MasterValue";
import OtherCharges from "./OtherCharges";
import { ReactDialogBox } from 'react-js-dialog-box'
import 'react-js-dialog-box/dist/index.css'
import { setElectricityCharges, setNewTariff, setOtherCharges, uploadNewTariff } from "./dispatch";
import { useDispatch, useSelector } from "react-redux";
import Container from 'react-bootstrap/Container';
import { Navigate, useNavigate } from "react-router";
import Moment from "react-moment";
import { fetchAllDropDownData, fetchDashboardSuccess } from "../dashboard/dispatch";
import { selectMonths } from "../../utils/utility";

const NewTariff = () => {
  const navigate = useNavigate();
  const [isActive, setActive] = useState('#MasterValue');
  const [isOpen, setIsOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const { masterValueData, electricityCharge, otherCharges, uploadDataNewTariff } = useSelector(state => state.newTariffReducer);
  const { dashboardData, subCategoryData, supplierTypeData, FCUnitData, RateTypeData, editsearchData, ChargingNameData, ChargingTypeData, ChargingParameterData, ChargingUnitData,allDropDownData } = useSelector(state => state.dashboardReducer);

  // const { data } = useSelector(state => state.loginReducer);
  const data =  JSON.parse(localStorage.getItem("USER_DETAILS")); 
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(fetchDashboardSuccess(data))
    dispatch(fetchAllDropDownData(data))
    dispatch(setNewTariff(null))
    dispatch(setElectricityCharges(null))
    dispatch(setOtherCharges(null))
  }, [])
  useEffect(() => {
    if (uploadDataNewTariff?.ERROR_STATUS) {
      openBox()

    }
  }, [uploadDataNewTariff])

  const handleClick = (e, p) => {
    if (e == '#OtherValuePreview') {
      setTimeout(() => {
        setActive("#OtherValue")
      }, 200);
      setIsPreviewOpen(true);
    }
    setTimeout(() => {
      console.log(masterValueData)
    }, 500);
    // if(isActive == "#ElectricityValue")
    // setActive('#ElectricityValue'); 
    // if(isActive == "#ElectricityValue"||e == "#ElectricityValue")
    // setNewTariff()
    setActive(e);
    console.log(e);
    // openBox()
  };

  const openBox = () => {
    setIsOpen(true)
  }

  const closeBox = () => {
    setIsOpen(false)
  }




  const displayRateType = (CHARGE_ID) => {
    return RateTypeData?.pDATASET?.map((name, index) => {
      if (name.RATETYPE_ID == Number(CHARGE_ID)) {
        return name.RATETYPE_NAME
      }
    })
  }

  const displayUnitData = (CHARGE_ID) => {
    return FCUnitData?.pDATASET?.map((name, index) => {
      if (name.ID == Number(CHARGE_ID)) {
        return name.NAME
      }
    })
  }

  const displayMonth = (CHARGE_ID) => {
    return selectMonths?.map((name, index) => {
      if ((index + 1) == Number(CHARGE_ID)) {
        return name
      }
    })
  }


  const displayTableChargeName = (CHARGE_ID) => {
    return ChargingNameData?.pDATASET?.map((name, index) => {
      if (name.CHARGE_ID == Number(CHARGE_ID)) {
        return name.CHARGE_NAME
      }
    })
  }

  const displayTableChargeType = (CHARGE_ID) => {
    return ChargingTypeData?.pDATASET?.map((name, index) => {
      if (name.CHARGETYPE_ID == Number(CHARGE_ID)) {
        return name.CHARGETYPE_NAME
      }
    })
  }

  const displayTableParameterData = (CHARGE_ID) => {
    return ChargingParameterData?.pDATASET?.map((name, index) => {
      if (name.PARAM_ID == Number(CHARGE_ID)) {
        return name.PARAMETER_NAME
      }
    })
  }

  const displayTableUnitData = (CHARGE_ID) => {
    return ChargingUnitData?.pDATASET?.map((name, index) => {
      if (name.ID == Number(CHARGE_ID)) {
        return name.NAME
      }
    })
  }

  const displayCategoryData = (CHARGE_ID) => {
    return dashboardData?.pDATASET?.map((name, index) => {
      if (name.CATEGORY_ID == Number(CHARGE_ID)) {
        return name.CATEGORY_NAME
      }
    })
  }

  const displaySupplierData = (CHARGE_ID) => {
    return supplierTypeData?.pDATASET?.map((name, index) => {
      if (name.SUPPLIERTYPE_ID == Number(CHARGE_ID)) {
        return name.SUPPLIERTYPE_NAME
      }
    })
  }

  const displayAllDropData = (CHARGE_ID) => {
    return allDropDownData?.pDATASET.map((item) => {
      if (item.TYPE == 'TCUNIT'&&item.ID == Number(CHARGE_ID)) {
        return <option value={item.ID}>{item.NAME}</option>
      }
    })
  }



  const renderPreview = () => {
    return (
      <ReactDialogBox
        closeBox={() => { setIsPreviewOpen(false) }}
        modalWidth='90%'
        headerBackgroundColor='#E9E9E9'
        headerTextColor='white'
        headerHeight='60px'
        closeButtonColor='black'
        bodyBackgroundColor='white'
        bodyTextColor='black'
        // bodyHeight='780px'
        headerText={<div><div style={{ color: '#000', marginTop: 10 }}>Preview</div> <div style={{ position: 'absolute', right: '7%', top: 15 }}> <Button variant="primary" style={{ marginLeft: 15 }}
          onClick={() => {
            setIsPreviewOpen(false)
            dispatch(setOtherCharges(otherCharges))
            let masterValue = { masterValueData, electricityCharge, otherCharges }
            let userData = { masterValue: masterValue, data: data, id: editsearchData?.data?.masterValueData?.TariffId }
            dispatch(uploadNewTariff(userData))

            // setTimeout(() => {
            //   setIsPreviewOpen(false)
            // }, 0);
          }}
        >Submit</Button></div> </div>}
      >
        <div style={{ overflow: 'auto', height: '300px' }}>
          <div style={{ padding: '7px 0px 5px 15px', color: '#fff', background: '#33A4DA' }} onClick={() => { setIsPreviewOpen(false); setActive("#MasterValue") }} >
            Master Value
            <img src={require('../../assets/Edit.png')} style={{
              float: 'right',
              paddingRight: '10px',
            }} />
          </div>


          <Row style={{ marginTop: 10, padding: '4px', fontFamily: "Roboto-Light", }}>
            <Col sm>Tariff ID</Col>
            <Col sm>Tariff name</Col>
            <Col sm>Description</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Regular", }}>
            <Col sm>{uploadDataNewTariff?.PTARIFFID}</Col>
            <Col sm>{masterValueData?.TariffName}</Col>
            <Col sm>{masterValueData?.TariffDescription}</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Light", }}>
            <Col sm>Service Category</Col>
            <Col sm>Sub Category</Col>
            <Col sm>Supplier Type</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Regular", }}>
            <Col sm>{displayCategoryData(masterValueData?.TariffServiceCategory)}</Col>
            <Col sm>{masterValueData?.TariffSubCategoryCategory}</Col>
            <Col sm>{displaySupplierData(masterValueData?.TariffServiceTypeCategory)}</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Light", }}>
            <Col sm>Valid From</Col>
            <Col sm>Valid To</Col>
            <Col sm>Fixed Charges</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Regular", }}>
            <Col sm><Moment format="DD/MM/YYYY">
              {masterValueData?.TariffValidFrom}
            </Moment></Col>
            <Col sm><Moment format="DD/MM/YYYY">
              {masterValueData?.TariffValidTo}
            </Moment></Col>
            <Col sm>{masterValueData?.TariffFixedCharges}</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Light", }}>
            <Col sm>FC Unit</Col>
            <Col sm>FC Subsidy</Col>
            <Col sm>Tariff Cycle</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Regular", }}>
            <Col sm>{masterValueData?.TariffFixedUnit}</Col>
            <Col sm>{masterValueData?.TariffFixedSubsidy}</Col>
            <Col sm>{displayAllDropData(masterValueData?.TariffCycle)}</Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Light", }}>
            <Col sm>Minimum Charges</Col>
            <Col sm>Maximum Charges</Col>
            <Col sm></Col>
          </Row>
          <Row style={{ padding: '4px', fontFamily: "Roboto-Regular", }}>
            <Col sm>{masterValueData?.TariffFixedMinimumCharges}</Col>
            <Col sm>{masterValueData?.TariffFixedMaximumCharges}</Col>
            <Col sm></Col>
          </Row>
          <div style={{ padding: '7px 0px 5px 15px', color: '#fff', background: '#33A4DA' }} onClick={() => { setIsPreviewOpen(false); setActive("#ElectricityValue") }} >
            Electricity Charges
            <img src={require('../../assets/Edit.png')} style={{
              float: 'right',
              paddingRight: '10px',
            }} />
          </div>

          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Season Start - Season End</th>
                <th scope="col">Rate Type</th>
                <th scope="col">From Rate Type</th>
                <th scope="col">To Rate Type</th>
                <th scope="col">Unit</th>
                <th scope="col">Value</th>
                <th scope="col">Subsidy</th>
              </tr>
            </thead>
            <tbody>
              {electricityCharge?.map((item) => {
                return <tr>
                  <th scope="col"></th>
                  <td>{displayMonth(item?.SeasonStarts)}-{displayMonth(item?.SeasonEnds)}</td>
                  <td>{displayRateType(item?.RateType)}</td>
                  <td>{item.FromRateType}</td>
                  <td>{item.ToRateType}</td>
                  <td>{item.Subsidy}</td>
                  <td>{displayUnitData(item?.Unit)}</td>
                  <td>{item.Value}</td>
                </tr>
              })}
            </tbody>
          </table>
          <div style={{ padding: '7px 0px 5px 15px', color: '#fff', background: '#33A4DA' }} onClick={() => { setIsPreviewOpen(false); setActive("#OtherValue") }} >
            Other Charges
            <img src={require('../../assets/Edit.png')} style={{
              float: 'right',
              paddingRight: '10px',
            }} />
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Charge Name</th>
                <th scope="col">Charge Type</th>
                <th scope="col">Charging Parameter</th>
                <th scope="col">Charging Unit</th>
                <th scope="col">Charge Value</th>
              </tr>
            </thead>
            <tbody>
              {otherCharges?.map((item) => {
                return <tr>
                  <th scope="row">{item.FromRateType}</th>
                  <td>{displayTableChargeName(item?.ChargeName)}{item?.ChargeName}</td>
                  <td>{displayTableChargeType(item?.ChargeType)}</td>
                  <td>{displayTableParameterData(item?.ChargingParameter)}</td>
                  <td>{displayTableUnitData(item?.ChargingUnit)}</td>
                  <th scope="row">{item?.ChargeValue}</th>
                </tr>
              })}
            </tbody>
          </table>

        </div>
      </ReactDialogBox>
    );
  }
  return (
    <>
      <Card style={{ height: '94px', width: '100%', backgroundColor: '#17234D', borderRadius: '0px' }}>
        <Card.Body>
          <Card.Title style={{ color: '#fff', fontFamily: "Roboto-Regular", fontSize: '25px' }}>New Tariff</Card.Title>
          <Card.Text style={{ color: '#fff', fontFamily: "Roboto-Light", fontSize: '15px' }}>
            Add new tariff plan with details
          </Card.Text>
        </Card.Body>
      </Card>
      <Card style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', margin: '30px' }}>
        <Card.Header style={{ padding: '0px 0px 0px 20px', marginTop: '10px', bottom: '20px', backgroundColor: 'white' }}>
          <Nav variant="underline" activeKey={isActive}
            onSelect={(selectedKey) => { setActive(selectedKey); console.log(`selected ${selectedKey}`) }}
          >
            <Nav.Item>
              <Nav.Link href="#MasterValue" eventKey="#MasterValue" style={{ fontFamily: "Roboto-Regular", fontSize: '17px' }}>Master Value</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#ElectricityValue" eventKey="#ElectricityValue" style={{ fontFamily: "Roboto-Regular", fontSize: '17px' }}>Utility Charges</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#OtherValue" eventKey="#OtherValue" style={{ fontFamily: "Roboto-Regular", fontSize: '17px' }}>Other Charges</Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
        <Card.Body  className = {isActive === "#ElectricityValue" ? "p-0" : null} style={{ maxHeight: '65vh', overflowY: 'auto', paddingBottom: '5%' }}>
          {isActive == "#ElectricityValue" ? <UtilityCharges onClick={handleClick} /> : isActive == "#OtherValue" ? <OtherCharges onClick={handleClick} /> : <MasterValue onClick={handleClick} />}
          {isOpen ? <ReactDialogBox
            closeBox={closeBox}
            modalWidth='25%'
            headerBackgroundColor='#E9E9E9'
            headerTextColor='white'
            headerHeight='60px'
            closeButtonColor='black'
            bodyBackgroundColor='white'
            bodyTextColor='black'
            bodyHeight='150px'
            headerText=''
          >
            <div style={{ height: 75, paddingTop: 15 }}>
              <h5 style={{ textAlign: 'center' }}>Tariff Succefully Created!!</h5>
              <h5 style={{ textAlign: 'center' }}>Your tariff ID is - {uploadDataNewTariff?.PTARIFFID}</h5>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Button variant="primary" type="submit" onClick={() => {
                closeBox();
                //  setActive("#MasterValue");
                navigate("/SerchTariff");
                dispatch(setNewTariff(null))
                dispatch(setElectricityCharges(null))
                dispatch(setOtherCharges(null))
                let userData = { masterValue: null, data: data, id: editsearchData?.data?.masterValueData?.TariffId }
                dispatch(uploadNewTariff(userData));
              }}>
                ok
              </Button>
            </div>
          </ReactDialogBox> : null}
          {isPreviewOpen ? renderPreview() : null}
        </Card.Body>
      </Card>
    </>
  );
};

export default NewTariff;
